import React from 'react';
import SubmitBtn from '../submit-btn/submit-btn';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  form: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: theme.spacing(3),
  },
  input: {
    marginBottom: theme.spacing(3),
    flex: 1,
  },
  gridItem: {
    display: 'flex',
  },
  loading: {
    marginRight: theme.spacing(1),
  },
  header: {
    marginTop: theme.spacing(3),
  },
  actions: {
    display: 'flex',
    gap: `${theme.spacing(2)}px`,
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      width: '100%',
    },
  },
  actionBtn: {
    flex: 1,
  },
}));

type ThreeBtnProps = {
  primaryTitle: string;
  primaryOnClick: () => void;
  secondaryTitle: string;
  secondaryOnClick: () => void;
  isPrimarySubmitting?: boolean;
  isSecondarySubmitting?: boolean;
  disabled?: boolean;
};

export const ThreeBtn = ({
  primaryTitle,
  primaryOnClick,
  secondaryTitle,
  secondaryOnClick,
  isPrimarySubmitting,
  isSecondarySubmitting,
  disabled,
}: ThreeBtnProps) => {
  const classes = useStyles();

  return (
    <div className={classes.actions}>
      <SubmitBtn
        type="button"
        title={primaryTitle}
        variant="contained"
        color="primary"
        isSubmitting={isPrimarySubmitting}
        onClick={primaryOnClick}
        disabled={disabled}
      />

      <SubmitBtn
        type="button"
        title={secondaryTitle}
        color="primary"
        isSubmitting={isSecondarySubmitting}
        onClick={secondaryOnClick}
        disabled={disabled}
      />
    </div>
  );
};

export default ThreeBtn;
